<div class="nofondPage unity-padding-web unity-padding-h5-12">
  <div class="nofondPage-content">
    <img class="nofondPage-content-top" src="assets/images/nofondpage.png" alt="" />
    <div class="nofondPage-content-bottom">
      <span class="tips">{{ 'no_page' | translate }}</span>
      <div class="back onact96-not" (click)="goHome()">{{ 'back' | translate }} {{ 'home' | translate }}</div>
    </div>
  </div>
</div>
